export default "__VITE_ASSET__BQm1mWwm__"